import React from 'react';

import {Box, Grid} from '@material-ui/core';
import PropTypes, {InferProps} from 'prop-types';

import {EfeCommonRow} from 'components';
import {FieldShape} from 'commons/shapes';
import {Field, Row} from 'commons/models';
import {notEmpty} from 'commons/utils/Functions';

EfeFormSection.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
    values: PropTypes.any.isRequired,
    errors: PropTypes.any.isRequired,
    setFieldValue: PropTypes.func.isRequired,
};

function EfeFormSection(props: InferProps<typeof EfeFormSection.propTypes>) {
    const {fields, values, errors, setFieldValue} = props;
    const [commonFields, setCommonFields] = React.useState<Array<Row>>([]);

    React.useEffect(() => {
        let grid = 0;
        const tempCommon: Array<Row> = [];
        let tempFields: Array<Field> = [];
        fields.map((field: Field, index: number) => {
            if (notEmpty(field.typeElement) && field.typeElement.length) {
                if (field.gridSize === 12 && grid <= 0) {
                    tempCommon.push({
                        row: [field],
                        index: index,
                    });
                } else if (field.gridSize === 12 && grid > 0) {
                    tempCommon.push({
                        row: [...tempFields],
                        index: index - 1,
                    });
                    tempCommon.push({
                        row: [field],
                        index: index,
                    });
                    tempFields = [];
                    grid = 0;
                } else if (grid + field.gridSize > 12) {
                    tempCommon.push({
                        row: [...tempFields],
                        index: index - 1,
                    });
                    tempFields = [field];
                    grid = field.gridSize;
                } else {
                    grid += field.gridSize;
                    tempFields.push(field);
                }
            }
        });
        if (tempFields && tempFields.length) {
            tempCommon.push({
                row: [...tempFields],
                index: fields.length,
            });
        }
        setCommonFields([...tempCommon]);
    }, [fields]);

    /* eslint-disable react/jsx-handler-names */
    return (
        <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
            <Grid container spacing={2} justifyContent={'space-between'}>
                {commonFields &&
                    commonFields.length > 0 &&
                    commonFields.map((rows: Row, key: number) => {
                        return (
                            <EfeCommonRow
                                rows={rows}
                                key={`item${key}-row${rows.index}`}
                                setFieldValue={setFieldValue}
                                values={values}
                                errors={errors}
                            />
                        );
                    })}
            </Grid>
        </Box>
    );
}

export default EfeFormSection;
